module.exports = __webpack_public_path__ + "img/attach_file_add.14d87677.svg";